"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DropdownButton = exports.DropdownStyledIcon = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_1 = __importDefault(require("@emotion/styled"));
const react_1 = require("@headlessui/react");
const should_forward_prop_1 = __importDefault(require("@styled-system/should-forward-prop"));
const useDropdownProps_1 = require("./useDropdownProps");
const styles_1 = require("../../constants/styles");
const Icon_1 = require("../Icon");
/**
 * Prevents the element from collapsing if the content is "".
 */
const NARROW_NO_BREAK_SPACE = ' ';
const DropdownButtonElement = (0, styled_1.default)(react_1.Menu.Button, {
    shouldForwardProp: should_forward_prop_1.default,
})(styles_1.dropdownButtonStyles);
exports.DropdownStyledIcon = (0, styled_1.default)(Icon_1.Icon)(({ hasLabel }) => ({
    marginLeft: 8,
    pointerEvents: 'none',
    position: 'absolute',
    right: hasLabel ? 4 : 0,
    top: '50%',
    transform: 'translate(-50%, -50%)',
}));
const DropdownButton = (props) => {
    const dropdownProps = (0, useDropdownProps_1.useDropdownProps)();
    const design = props.design ?? dropdownProps.design;
    return ((0, jsx_runtime_1.jsxs)(DropdownButtonElement, { className: props.className, compact: props.compact, design: design, fullWidth: props.fullWidth, noText: props.text === undefined, onBlur: props.onBlur, size: props.size, children: [(0, jsx_runtime_1.jsx)(exports.DropdownStyledIcon, { name: props.icon ?? 'ChevronDownIcon', hasLabel: !!props.text }), props.text || NARROW_NO_BREAK_SPACE] }));
};
exports.DropdownButton = DropdownButton;
